export const hullTypes = ["Double Bottom", "Double Hull", "Double Side", "Other", "Single Hull"];
